var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseClaims } from "../authentication/base-claims";
var LotteryPlatformClaims = /** @class */ (function (_super) {
    __extends(LotteryPlatformClaims, _super);
    function LotteryPlatformClaims() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LotteryPlatformClaims.PlayerIpAddressLog = "PlayerIpAddressLog";
    LotteryPlatformClaims.PlayerKyc = "PlayerKyc";
    LotteryPlatformClaims.PlayerDetails = "PlayerDetails";
    LotteryPlatformClaims.PlayerChangeLog = "PlayerChangeLog";
    LotteryPlatformClaims.PlayerTicketLines = "PlayerTicketLines";
    LotteryPlatformClaims.PlayerTicketDraws = "PlayerTicketDraws";
    LotteryPlatformClaims.PlayerTransactions = "PlayerTransactions";
    LotteryPlatformClaims.PlayerBasicMeta = "PlayerBasicMeta";
    LotteryPlatformClaims.DeleteBrand = "DeleteBrand";
    LotteryPlatformClaims.DeleteOperator = "DeleteOperator";
    LotteryPlatformClaims.PlatformAdmin = "PlatformAdmin";
    LotteryPlatformClaims.ManageDefaultTemplateTheme = "ManageDefaultTemplateTheme";
    LotteryPlatformClaims.ManageDefaultOverlayTheme = "ManageDefaultOverlayTheme";
    LotteryPlatformClaims.ViewAffiliateLinkAnalytics = "ViewAffiliateLinkAnalytics";
    LotteryPlatformClaims.ViewSupportPage = "ViewSupportPage";
    LotteryPlatformClaims.ViewPlayer = "ViewPlayer";
    LotteryPlatformClaims.CreateInstantGame = "CreateInstantGame";
    LotteryPlatformClaims.CreateLottery = "CreateLottery";
    LotteryPlatformClaims.EditLotteries = "EditLotteries";
    LotteryPlatformClaims.EditInstantGame = "EditInstantGame";
    LotteryPlatformClaims.ListLotteries = "ListLotteries";
    LotteryPlatformClaims.ListInstantGames = "ListInstantGames";
    LotteryPlatformClaims.ListPlayers = "ListPlayers";
    LotteryPlatformClaims.ListTransactions = "ListTransactions";
    LotteryPlatformClaims.ViewTransaction = "ViewTransaction";
    LotteryPlatformClaims.ListBrands = "ListBrands";
    LotteryPlatformClaims.ListOperators = "ListOperators";
    LotteryPlatformClaims.CreateBrand = "CreateBrand";
    LotteryPlatformClaims.CreateOperator = "CreateOperator";
    LotteryPlatformClaims.EditBrands = "EditBrands";
    LotteryPlatformClaims.ViewBrands = "ViewBrands";
    LotteryPlatformClaims.EnableAgent = "EnableAgent";
    LotteryPlatformClaims.EditOperators = "EditOperator";
    LotteryPlatformClaims.ListTicketLines = "ListTicketLines";
    LotteryPlatformClaims.ListTicketDraws = "ListTicketDraws";
    LotteryPlatformClaims.CreateWinningClaims = "CreateWinningClaims";
    LotteryPlatformClaims.ListWinningClaims = "ListWinningClaims";
    LotteryPlatformClaims.ManageWinningClaim = "ManageWinningClaim";
    LotteryPlatformClaims.ShowAllCosts = "ShowAllCosts";
    LotteryPlatformClaims.OperatorShowCostsOfPlatformMargins = "OperatorShowCostsOfPlatformMargins";
    LotteryPlatformClaims.ManageLotterySubscription = "ManageLotterySubscription";
    LotteryPlatformClaims.OperatorShowCostsOfOperatorMargins = "OperatorShowCostsOfOperatorMargins";
    LotteryPlatformClaims.BrandShowCostsOfPlatformMargins = "BrandShowCostsOfPlatformMargins";
    LotteryPlatformClaims.BrandShowCostsOfOperatorMargins = "BrandShowCostsOfOperatorMargins";
    LotteryPlatformClaims.InstantGamesBrandShowCostsOfPlatformMargins = "InstantGamesBrandShowCostsOfPlatformMargins";
    LotteryPlatformClaims.InstantGamesBrandShowCostsOfOperatorMargins = "InstantGamesBrandShowCostsOfOperatorMargins";
    LotteryPlatformClaims.BrandLevelLotteryMarginCosts = "BrandLevelLotteryMarginCost";
    LotteryPlatformClaims.SweepstakesBrandShowCostsOfPlatformMargins = "SweepstakeBrandShowCostsOfPlatformMargins";
    LotteryPlatformClaims.SweepstakesBrandShowCostsOfOperatorMargins = "SweeptakesBrandShowCostsOfOperatorMargins";
    LotteryPlatformClaims.SweepstakesOperatorShowCostsOfPlatformMargins = "SweeptakesOperatorShowCostsOfPlatformMargins";
    LotteryPlatformClaims.SweepstakesOperatorShowCostsOfOperatorMargins = "SweepstakesOperatorShowCostsOfOperatorMargins";
    LotteryPlatformClaims.InstantGamesOperatorShowCostsOfPlatformMargins = "InstantGamesOperatorShowCostsOfPlatformMargins";
    LotteryPlatformClaims.InstantGamesOperatorShowCostsOfOperatorMargins = "InstantGamesOperatorShowCostsOfOperatorMargins";
    LotteryPlatformClaims.BundlesOperatorShowCostsOfPlatformMargins = "BundlesOperatorShowCostsOfPlatformMargins";
    LotteryPlatformClaims.BundlesOperatorShowCostsOfOperatorMargins = "BundlesOperatorShowCostsOfOperatorMargins";
    LotteryPlatformClaims.BundlesBrandShowCostsOfPlatformMargins = "BundlesBrandShowCostsOfPlatformMargins";
    LotteryPlatformClaims.BundlesBrandShowCostsOfOperatorMargins = "BundlesBrandShowCostsOfOperatorMargins";
    LotteryPlatformClaims.SyndicatesOperatorShowCostsOfPlatformMargins = "SyndicatesOperatorShowCostsOfPlatformMargins";
    LotteryPlatformClaims.SyndicatesOperatorShowCostsOfOperatorMargins = "SyndicatesOperatorShowCostsOfOperatorMargins";
    LotteryPlatformClaims.SyndicatesBrandShowCostsOfPlatformMargins = "SyndicatesBrandShowCostsOfPlatformMargins";
    LotteryPlatformClaims.SyndicatesBrandShowCostsOfOperatorMargins = "SyndicatesBrandShowCostsOfOperatorMargins";
    LotteryPlatformClaims.ManageStatusReasonTransitions = "ManageStatusReasonTransitions";
    LotteryPlatformClaims.ManageTemplates = "ManageTemplates";
    LotteryPlatformClaims.ManageLotteryWidgets = "ManageLotteryWidgets";
    LotteryPlatformClaims.BrandOverview = "BrandOverview";
    LotteryPlatformClaims.BrandAnalytics = "BrandAnalytics";
    LotteryPlatformClaims.BrandTransactions = "BrandTransactions";
    LotteryPlatformClaims.BrandLotteries = "BrandLotteries";
    LotteryPlatformClaims.LotteryGrouping = "LotteryGrouping";
    LotteryPlatformClaims.BrandInstantGames = "BrandInstantGames";
    LotteryPlatformClaims.BrandBundles = "BrandBundles";
    LotteryPlatformClaims.BrandLotteryInsurance = "BrandLotteryInsurance";
    LotteryPlatformClaims.BrandLotteryTicketCosts = "BrandLotteryTicketCosts";
    LotteryPlatformClaims.BrandPlayers = "BrandPlayers";
    LotteryPlatformClaims.BrandSettings = "BrandSettings";
    LotteryPlatformClaims.BrandBilling = "BrandBilling";
    LotteryPlatformClaims.BrandNotifications = "BrandNotifications";
    LotteryPlatformClaims.BrandSweepstakes = "BrandSweepstakes";
    LotteryPlatformClaims.OperatorOverview = "OperatorOverview";
    LotteryPlatformClaims.OperatorBrands = "OperatorBrands";
    LotteryPlatformClaims.OperatorTransactions = "OperatorTransactions";
    LotteryPlatformClaims.OperatorLotteryTicketPricing = "OperatorLotteryTicketPricing";
    LotteryPlatformClaims.OperatorBundles = "OperatorBundles";
    LotteryPlatformClaims.OperatorLotteryInsurance = "OperatorLotteryInsurance";
    LotteryPlatformClaims.OperatorLotteryTicketCosts = "OperatorLotteryTicketCosts";
    LotteryPlatformClaims.OperatorPlayers = "OperatorPlayers";
    LotteryPlatformClaims.OperatorTicketSales = "OperatorTicketSales";
    LotteryPlatformClaims.OperatorBilling = "OperatorBilling";
    LotteryPlatformClaims.EditLotteryInsurance = "EditLotteryInsurance";
    LotteryPlatformClaims.ShowBilling = "ShowBillings";
    LotteryPlatformClaims.ViewBrandCredit = "ViewBrandCredit";
    LotteryPlatformClaims.ViewOperatorCredit = "ViewOperatorCredit";
    LotteryPlatformClaims.EditBrandCredit = "EditBrandCredit";
    LotteryPlatformClaims.EditOperatorCredit = "EditOperatorCredit";
    LotteryPlatformClaims.ManageOperatorLotterySubscription = "ManageOperatorLotterySubscription";
    LotteryPlatformClaims.ManageApiSettings = "ManageApiSettings";
    LotteryPlatformClaims.ReviewDrawResult = "ReviewDrawResult";
    LotteryPlatformClaims.UpdateDrawResult = "UpdateDrawResult";
    LotteryPlatformClaims.CreateSweepstake = "CreateSweepstake";
    LotteryPlatformClaims.EditSweepstake = "EditSweepstake";
    LotteryPlatformClaims.ListSweepstakes = "ListSweepstakes";
    return LotteryPlatformClaims;
}(BaseClaims));
export { LotteryPlatformClaims };
